import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import {
  FaUserCheck,
  FaIdCard,
  FaExternalLinkAlt,
  FaListAlt,
  FaCheckCircle,
  FaFileUpload,
} from "react-icons/fa";
import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";
import AdBanner from "../AdPage/AdBanner";
const KotakMahindra = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }

  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  // const currentCards = CreditCardData.cards
  //   ?.filter((card) => card.category === "Credit card")
  //   .slice(indexOfFirstCard, indexOfLastCard);
  // console.log({ currentCards });
  const currentCards = CreditCardData.cards
    ?.filter((card) => card.title?.toLowerCase().includes("kotak"))
    .slice(indexOfFirstCard, indexOfLastCard);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const faqs = [
    {
      question: "Does Kotak offer lifetime free credit cards?",
      answer:
        "  Yes, cards like the Kotak 811 #DreamDifferent Credit Card are available with no annual fees and are ideal for first-time users.",
    },
    {
      question: "Which Kotak card is best for cashback?",
      answer:
        "   The Kotak Delight Platinum Credit Card and Essentia Platinum Card offer attractive cashback on dining, fuel, and groceries.",
    },
    {
      question: "Are Kotak cards suitable for travelers?",
      answer:
        "  Select premium cards offer railway surcharge waivers, airport lounge access, and travel insurance benefits, making them travel-friendly.",
    },
    {
      question: "Can I convert spends into EMIs?",
      answer:
        "  Yes, Kotak credit cards allow easy EMI conversions on large spends through NetBanking or customer service.",
    },
    {
      question: "How long does it take to get a Kotak card approved?",
      answer:
        "  If all documents are in order, approvals typically take 5–7 working days, and the card is delivered within 7–10 days after that.",
    },
  ];

  const steps = [
    {
      icon: <FaCheckCircle className="h-6 w-6 text-orange-500" />,
      title: "Check Your Eligibility",
      description:
        "  Make sure your income level, location, and credit score align with the criteria for the card you’re applying for.",
    },
    {
      icon: <FaFileUpload className="h-6 w-6 text-green-500" />,
      title: "Gather Documents",
      description:
        " Keep your identity, address, and income documents ready for submission during the application or verification stage.",
    },
    {
      icon: <FaExternalLinkAlt className="h-6 w-6 text-purple-600" />,
      title: "Redirect to Kotak's Official Page",
      description:
        "   Click on the “Apply Now” button on TheFinMaster to securely proceed to Kotak Mahindra Bank’s official credit card application portal for form submission and KYC.",
    },
    {
      icon: <FaListAlt className="h-6 w-6 text-teal-500" />,
      title: "Explore & Compare with TheFinMaster",
      description:
        "  Head to TheFinMaster and explore our well-researched selection of Kotak Mahindra credit cards. We provide card-wise comparisons covering features, cashback offers, fees, eligibility, and user-specific recommendations to help you make a confident choice.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>
        Kotak Mahindra Bank Credit Cards – Plans, Benefits & Application Process
        </title>
        <meta
          name="description"
          content="Explore Kotak Mahindra Bank’s credit card options, their benefits, eligibility criteria, and application process to choose the right card for your financial needs."
        />
        <meta
          name="keywords"
          content="abank of baroda lifetime free credit card, bob easy credit card apply, bank of baroda hpcl credit card, bank of baroda snapdeal credit card, bobcard payment"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/kotak-mahindra-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <div className="w-full flex flex-col items-center ">
        <div className="w-full flex flex-col items-center ">
          <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
            <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
              Kotak Mahindra Bank Credit Cards
            </h1>
            <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
              Experience financial freedom and flexibility with our credit card
              options.
            </p>
          </div>
        </div>
        <div className="flex justify-center items-center  p-4 ">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Discover Versatile Cards for Smart Spending, Rewards, and
              Financial Flexibility{" "}
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              Kotak Mahindra Bank offers a thoughtfully curated range of credit
              cards tailored to meet varied financial goals—whether you're a
              frequent traveler, a movie buff, or a cashback enthusiast. Known
              for their affordable fee structure and focused reward programs,
              Kotak cards deliver real value through savings, lifestyle
              privileges, and EMI options. From entry-level cards to premium
              variants, there's something for everyone in Kotak’s diverse credit
              card portfolio.
            </p>
          </div>
        </div>
        <h2 className="text-center text-2xl md:text-3xl font-bold text-gray-800  my-10">
          Featured Credit Cards
        </h2>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

          <div className="w-full relative ">
                    <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
                      {/* <div className="w-[70%] mx-auto">
                                                 <h2 className="text-center font-medium pt-5 text-lg">
                                                   <span className="font-semibold text-white">816 people</span>{" "}
                                                   are on call with our advisors right now
                                                 </h2>
                                               </div> */}
                      <div className="w-full mx-auto">
                      
                          <div className="w-[80%] mx-auto ">
                          <AdBanner displayOrder="2" />
                          </div>
                       
                        <div className="bg-white">
                          {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                                     Know your advisor
                                                   </h3> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

        {/* <div className='w-[95%] py-10'>
                                         <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
                                         <AccordionComponent />
                                     </div> */}

        <div className="w-full px-2 py-2 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for Kotak Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Age Requirement
                  </span>
                  <span>
                    {" "}
                    Applicants must be at least 21 years old for primary cards
                    and 18 years old for add-on cards.{" "}
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Monthly Income
                  </span>
                  <span>
                    {" "}
                    A net monthly income of ₹25,000–₹30,000 is generally
                    required, depending on the card variant. Premium cards may
                    have higher thresholds.
                  </span>{" "}
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    CIBIL Score & Credit History
                  </span>
                  <span>
                    {" "}
                    A CIBIL score of 750 or higher with a clean repayment record
                    is ideal. Poor credit history may reduce approval chances.{" "}
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Location-Based Eligibility
                  </span>
                  <span>
                    {" "}
                    Kotak Mahindra credit cards are available in selected
                    cities. Your residential or official address should fall
                    within the bank’s serviceable areas.{" "}
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Employment Type
                  </span>
                  <span>
                    {" "}
                    Salaried individuals with stable income and self-employed
                    professionals with verifiable financials are eligible to
                    apply.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for Kotak Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Identity
                  </span>
                  <span>
                    {" "}
                    Acceptable ID includes Aadhaar Card, Passport, PAN Card, or
                    Driving License, all with clear photo and matching details.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Address Proof
                  </span>
                  <span>
                    {" "}
                    Submit utility bills, Aadhaar, bank statements, or passport
                    showing current and valid residential address.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Income Proof
                  </span>
                  <span>
                    {" "}
                    Salaried: Latest 3 months’ salary slips or Form 16.
                    Self-Employed: ITR of last 2 years, profit & loss
                    statements, and bank records
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Photograph
                  </span>
                  <span>
                    {" "}
                    A clear, recent color photograph for verification,
                    especially during in-person KYC or documentation pickup.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    PAN Card
                  </span>
                  <span>
                    {" "}
                    Mandatory for financial verification and credit profiling
                    purposes.{" "}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          How to Apply for Kotak Mahindra Credit Card
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
                                   Applying for a fuel credit card is a seamless process that starts with
                                   the right research and ends at the official bank’s platform for final
                                   submission. Here’s how you can get started through TheFinMaster.com:
                                 </p> */}
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h2 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default KotakMahindra;
